import { Edit, TextInput, SimpleForm, required } from "react-admin";
import React from "react";
import { useAuthenticated } from "@s-graber/ra-rbac";

export const LeagueEdit: React.FC = (props) => {
  useAuthenticated();
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source="name" validate={required()} />
      </SimpleForm>
    </Edit>
  );
};
